export const tipoAjuste = {
    Ingreso: 4,
    Egreso: 5
}